import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementBalanceEmailTemplate.Save.IRequest;
type Response = Api.Core.ProviderStatementBalanceEmailTemplate.Save.IResponse;
type Headers = Api.Core.ProviderStatementBalanceEmailTemplate.Save.IHeaders;
const url = '/api/Management/ProviderStatementBalanceEmailTemplate';
export default async function providerStatementBalanceEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
